import { formattedMessageParams } from "../../messages";

/**
 * Creates data for Branded Fares Brands table - services names with their corresponding tooltip additional texts
 * @param serviceNames
 * @param intl
 * @param defineMessages
 */
const createServiceNamesData = (
  serviceNames: { Type: string; $t: string }[],
  intl: any
): { Type: string; $t: string; tooltipText: string }[] => {
  return serviceNames.map((serviceNameObject) => {
    const tooltipText = intl.formatMessage(
      formattedMessageParams(
        // we need to make sure that any key can be used here, therefore ignoring the type
        // @ts-ignore
        `BrandedFares.BrandServices.${serviceNameObject.Type}.Description`
      )
    );

    return {
      ...serviceNameObject,
      tooltipText,
    };
  });
};

export default createServiceNamesData;
